import classNames from "classnames";
import CSS from "csstype";
import React from "react";
import { getSpeakerIconUrl } from "../../app/helpers/urlHelper";
import { ISpeaker } from "../../app/models/podium";

interface IParams {
 
  speaker: ISpeaker;
  showTag: boolean;
  tagColor?: string;
  tagFont?: string;
  tagFontSize?: number;
  tagFontColor?: string;
  divSize: number;
  onSpeakerClick: () => void;
}

const PodiumSpeakerIconComponent: React.FC<IParams> = ({
 
  speaker,
  showTag,
  tagColor,
  tagFont,
  tagFontSize,
  tagFontColor,
  divSize,
  onSpeakerClick,
}) => {
  const iconUrl = getSpeakerIconUrl(speaker);
  const actualFontSize = tagFontSize ? tagFontSize * (divSize / 150) : 12;
  const cssStyle: CSS.Properties = {
    backgroundColor: tagColor ?? "0c0c0c",
    fontFamily: tagFont ?? "sans-serif",
    fontSize: `${actualFontSize * 0.8}px`,
    lineHeight: `${actualFontSize * 0.8}px`,
    padding: `${actualFontSize / 3}px`,
    color: tagFontColor ?? "#dcdc",
  };

  return (
    <div className="podium-icon-container">
      <div
        style={{
          height: divSize,
          width: divSize,
          padding: 10,
        }}
      >
        <div
          className={classNames(
            "podium-speaker-image-box",
            showTag && "podium-speaker-image-with-tag"
          )}
          onClick={onSpeakerClick}
        >
          <img
            className="podium-speaker-image"
            src={iconUrl}
            alt={speaker.name}
          ></img>
        </div>
        {showTag && (
          <div
            className="podium-speaker-tag "
            style={cssStyle}
            onClick={onSpeakerClick}
          >
            {speaker.name}
          </div>
        )}
      </div>
    </div>
  );
};

export default PodiumSpeakerIconComponent;
